// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper-progressBar {
    width: 100%
  }
  
  .progressBar {
  counter-reset: step;
  }
  
  .progressBar li {
    list-style-type: none;
    float: left;
    width: 25%;
    position: relative;
    text-align: center;
  }
  
  .progressBar li:before {
    cursor: pointer;
    content: counter(step);
    counter-increment: step;
    line-height: 30px;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    border: 2px solid #ddd;
    display: block;
    text-align: center;
    margin: 0 auto 10px;
    background-color: white
  }
  
  .progressBar li:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 2px;
    background-color: #ddd;
    top: 15px;
    left: -50%;
    z-index: -1;
  }
  
  .progressBar li:first-child:after {
    content: none;
  }
  
  .progressBar li.active {
    color: #007399;
  }
  
  .progressBar li.active:before {
    border-color: #007399;
    background-color: white;
  }
  
  .progressBar li.active:after {
    background-color: #007399;
}


.progressBar1 {
  counter-reset: step;
  }
  
  .progressBar1 li {
    list-style-type: none;
    float: left;
    width: 33.33%;
    position: relative;
    text-align: center;
  }
  
  .progressBar1 li:before {
    cursor: pointer;
    content: counter(step);
    counter-increment: step;
    line-height: 30px;
    border-radius: 50%;
    width: 30px;
    height: 30px;
    border: 2px solid #ddd;
    display: block;
    text-align: center;
    margin: 0 auto 10px;
    background-color: white
  }
  
  .progressBar1 li:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 2px;
    background-color: #ddd;
    top: 15px;
    left: -50%;
    z-index: -1;
  }
  
  .progressBar1 li:first-child:after {
    content: none;
  }
  
  .progressBar1 li.active {
    color: #007399;
  }
  
  .progressBar1 li.active:before {
    border-color: #007399;
    background-color: white;
  }
  
  .progressBar1 li.active:after {
    background-color: #007399;
}

/* .progressBar li.active + li:after {
  background-color: #007399;
} */

.circleSelling{
  margin-right: 10px;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  text-align: center;
  border: 2px solid rgb(0, 0, 0);
}`, "",{"version":3,"sources":["webpack://./src/includes/pages/addProduct.css"],"names":[],"mappings":"AAAA;IACI;EACF;;EAEA;EACA,mBAAmB;EACnB;;EAEA;IACE,qBAAqB;IACrB,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB;EACF;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qBAAqB;IACrB,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;AAC7B;;;AAGA;EACE,mBAAmB;EACnB;;EAEA;IACE,qBAAqB;IACrB,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB;EACF;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qBAAqB;IACrB,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;AAC7B;;AAEA;;GAEG;;AAEH;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;AAChC","sourcesContent":[".wrapper-progressBar {\n    width: 100%\n  }\n  \n  .progressBar {\n  counter-reset: step;\n  }\n  \n  .progressBar li {\n    list-style-type: none;\n    float: left;\n    width: 25%;\n    position: relative;\n    text-align: center;\n  }\n  \n  .progressBar li:before {\n    cursor: pointer;\n    content: counter(step);\n    counter-increment: step;\n    line-height: 30px;\n    border-radius: 50%;\n    width: 30px;\n    height: 30px;\n    border: 2px solid #ddd;\n    display: block;\n    text-align: center;\n    margin: 0 auto 10px;\n    background-color: white\n  }\n  \n  .progressBar li:after {\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    height: 2px;\n    background-color: #ddd;\n    top: 15px;\n    left: -50%;\n    z-index: -1;\n  }\n  \n  .progressBar li:first-child:after {\n    content: none;\n  }\n  \n  .progressBar li.active {\n    color: #007399;\n  }\n  \n  .progressBar li.active:before {\n    border-color: #007399;\n    background-color: white;\n  }\n  \n  .progressBar li.active:after {\n    background-color: #007399;\n}\n\n\n.progressBar1 {\n  counter-reset: step;\n  }\n  \n  .progressBar1 li {\n    list-style-type: none;\n    float: left;\n    width: 33.33%;\n    position: relative;\n    text-align: center;\n  }\n  \n  .progressBar1 li:before {\n    cursor: pointer;\n    content: counter(step);\n    counter-increment: step;\n    line-height: 30px;\n    border-radius: 50%;\n    width: 30px;\n    height: 30px;\n    border: 2px solid #ddd;\n    display: block;\n    text-align: center;\n    margin: 0 auto 10px;\n    background-color: white\n  }\n  \n  .progressBar1 li:after {\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    height: 2px;\n    background-color: #ddd;\n    top: 15px;\n    left: -50%;\n    z-index: -1;\n  }\n  \n  .progressBar1 li:first-child:after {\n    content: none;\n  }\n  \n  .progressBar1 li.active {\n    color: #007399;\n  }\n  \n  .progressBar1 li.active:before {\n    border-color: #007399;\n    background-color: white;\n  }\n  \n  .progressBar1 li.active:after {\n    background-color: #007399;\n}\n\n/* .progressBar li.active + li:after {\n  background-color: #007399;\n} */\n\n.circleSelling{\n  margin-right: 10px;\n  border-radius: 50%;\n  width: 25px;\n  height: 25px;\n  text-align: center;\n  border: 2px solid rgb(0, 0, 0);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
